<template>
    <div class="add-matrix">
      <div v-show="!selectedFile" class="upload-button">
        <div>
          <div>
            <label for="file-input-matrix">Загрузить файл маршрутов</label>
          </div> 
          <input id="file-input-matrix" type="file" ref="fileInput" accept=".xlsx, .xls" @change="handleFileChange" hidden/>
        </div>
      </div>

      <div>
        <button 
        v-if="selectedFile" 
        @click="submit" 
        class="upload-button">
        <p v-if="loading"><mini-loader></mini-loader></p>
        <p v-else>Отправить фаил</p>
        </button>
      </div>
    </div>
  </template>
  
  <script>
  import { ref } from 'vue';
  import ApiConnector from '@/backend/apiModels/userApi'
  import { createToaster } from "@meforma/vue-toaster";
  import { useErrorHandler } from '@/hooks/errorHandler';
  
  export default {
    name: 'UploadRoutes',
    setup() {
      const loading = ref(false)
      const fileInput = ref(null);
      const selectedFile = ref('');
      const api = new ApiConnector()
      const toaster = createToaster()
  
      const handleFileChange = () => {
        const file = fileInput.value.files[0];
        if (file) {
          selectedFile.value = file.name;
        } else {
          selectedFile.value = '';
        }
      };
      
      const submit = async () => {
        const file = fileInput.value.files[0];
        if (file && !loading.value) {
          try{
            loading.value = true
            const { response, request } = api.updateCustomerTable('ati/file',file);
            await request();
            toaster.success(response.value.msg)  
          }catch(err){
            useErrorHandler(err)
          }
          
        }
        fileInput.value = ''
        selectedFile.value = ''
        loading.value = false
      }
  
      return {
        loading,
        fileInput,
        selectedFile,
        handleFileChange,
        submit,
      };
    },
  };
  </script>
  
  <style scoped>
  .add-matrix {
    display: flex;
    flex-direction: column;
  }
  
  .loader {
    max-width: 20px;
    max-width: 20px;
  }

  .upload-button {
    height: 100%;
    border: none;
    padding: 10px 15px;
    border-radius: 4px;
    font-size: 14px;
    transition: background-color 0.3s;
    background-color: rgba(0, 123, 255,0.5);
  }

  .upload-button:hover {
    cursor: pointer;
    background-color: rgba(0, 123, 255,0.7);
  }
  </style>
  